import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Upload Sketch or Reference",
    body: "Pencil sketch, mood-board image, or photograph — Facetra accepts any starting point.",
  },
  {
    n: "02",
    title: "AI Generates Jewellery Concepts",
    body: "Multiple photoreal concepts arrive in seconds, faithful to the style you chose.",
  },
  {
    n: "03",
    title: "Multi-View + 3D Mesh",
    body: "Silhouette-locked 0° / 45° / 90° / 180° sheets, then a real photogrammetric 3D mesh (GLB / STL / OBJ / FBX) for your CAD bench.",
  },
  {
    n: "04",
    title: "Catalog · PhotoRoom · Export",
    body: "Save to the searchable Catalog, bulk-touchup finished pieces in PhotoRoom, or ship the full CAD kit to your karigar.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">How it works</p>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] text-white max-w-3xl">
            Four steps. <span className="italic gold-gradient-text">A new design floor.</span>
          </h2>
        </motion.div>

        <div className="mt-16 relative">
          {/* connecting line */}
          <div className="hidden lg:block absolute top-[34px] left-[5%] right-[5%] h-px gold-line" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                data-testid={`how-step-${i}`}
                className="relative"
              >
                <div className="relative w-16 h-16 mx-auto lg:mx-0 rounded-full bg-[#1A1A1A] border border-[#D4AF37]/40 flex items-center justify-center shadow-[0_0_30px_-8px_rgba(212,175,55,0.4)]">
                  <span className="font-display text-[#D4AF37] text-lg">{s.n}</span>
                  <span className="absolute inset-0 rounded-full border border-[#D4AF37]/20 animate-pulse" />
                </div>
                <div className="mt-6 text-center lg:text-left">
                  <h3 className="font-display text-xl md:text-2xl text-white tracking-tight">{s.title}</h3>
                  <p className="mt-3 text-sm text-white/55 leading-relaxed max-w-xs mx-auto lg:mx-0">{s.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
